import {ALL_REVIEWS} from '../../config/reviews';

const DEFAULT_REVIEW = ALL_REVIEWS[0];

export default function StarReviewSection({personaName, personaImage, personaId, reviewOverride}) {
    const found = personaId ? ALL_REVIEWS.find(r => r.id === personaId) : null;
    const name = personaName || found?.name || DEFAULT_REVIEW.name;
    const image = personaImage || found?.image || DEFAULT_REVIEW.image;
    const review = reviewOverride || found?.text || DEFAULT_REVIEW.text;

    return (
        <div className="max-w-[1110px] mx-auto px-4 py-10 md:py-20">
            <h2 className="text-[28px] md:text-[42px] font-bold text-brand-dark leading-[1.1] tracking-[-0.42px] mb-8 text-center">
                Отзыв{' '}
                <span className="text-gradient">от звезды</span>
            </h2>

            <div
                className="bg-white rounded-[30px] shadow-lg p-6 md:p-10 flex flex-col md:flex-row gap-6 md:gap-10 items-start">
                {/* Avatar + name */}
                <div className="flex flex-col items-center flex-shrink-0 w-full md:w-auto">
                    <div
                        className="w-[100px] h-[100px] md:w-[140px] md:h-[140px] rounded-full overflow-hidden border-4 border-brand-orange/30">
                        <img
                            src={image}
                            alt={name}
                            className="w-full h-full object-cover"
                        />
                    </div>
                    <p className="mt-3 font-bold text-brand-dark text-center text-sm md:text-base">{name}</p>
                    {/* Stars */}
                    <div className="flex gap-0.5 mt-1">
                        {[1, 2, 3, 4, 5].map(i => (
                            <svg key={i} width="20" height="20" viewBox="0 0 20 20" fill="#F59E0B">
                                <path
                                    d="M10 1l2.39 4.84 5.34.78-3.87 3.77.91 5.33L10 13.27l-4.77 2.51.91-5.33L2.27 6.68l5.34-.78L10 1z"/>
                            </svg>
                        ))}
                    </div>
                    <p className="text-xs text-gray-400 mt-1">Проверенная звезда</p>
                </div>

                {/* Review text */}
                <p className="flex-1 text-[15px] md:text-[17px] leading-[1.7] text-gray-700">
                    {review}
                </p>
            </div>
        </div>
    );
}
